import { render, staticRenderFns } from "./FullDialog2.vue?vue&type=template&id=722a4842&scoped=true"
import script from "./FullDialog2.vue?vue&type=script&lang=js"
export * from "./FullDialog2.vue?vue&type=script&lang=js"
import style0 from "./FullDialog2.vue?vue&type=style&index=0&id=722a4842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a4842",
  null
  
)

export default component.exports